import React from "react";
import { Segment } from "../../types/ConversationProps";
import Loader from "../../components/loader/Loader";
import { getFriendlyTimeDifferenceV2 } from "../../utils/friendlyDate";
import { TeamIcon } from "../../assets/icons/Team";

interface SegmentListProps {
    isLoadingSegments: boolean;
    segments: Segment[] | null;
    roomSearchKey: string;
    selectSegment: (segment: Segment) => void;
    currentSegment: Segment | null;
}

const SegmentList = ({ currentSegment, isLoadingSegments, segments, roomSearchKey, selectSegment }: SegmentListProps) => {
    return (
        <>
            {isLoadingSegments ? <Loader size={100} /> : segments?.length ? segments?.map(segment => {
                const emailSubscribedMembers = segment.members.map(member => member.defaultEmailAddress?.marketingStatus === 'SUBSCRIBED')?.length || 0;
                const smsSubscribedMembers = segment.members.map(member => member.defaultPhoneNumber?.marketingStatus === 'SUBSCRIBED')?.length || 0;
                return (
                    <div className={`segment-row ${currentSegment?.id === segment.id ? 'selected' : ''}`} key={`segment-row-${segment.id}`} onClick={() => selectSegment(segment)}>
                        <div className="left">
                            <div className="image chat-image">
                                <TeamIcon width={37} height={45} color="#fff" />
                            </div>
                            <div className="segment-details">
                                <div className="segment-name">{segment.name}</div>
                                <div className="segment-members">{segment.members.length ? `${emailSubscribedMembers} emails, ${smsSubscribedMembers} sms` : 'No members'}</div>
                            </div>
                        </div>
                        <div className="right">
                            <div className="segment-last-message-time">
                                {segment.messages?.[0]?.createdAt ? <div
                                    className="time">{getFriendlyTimeDifferenceV2(new Date(segment.messages[0].createdAt))}</div> : null}
                            </div>
                        </div>
                    </div>
                )}
            ) : <div>No segments (empty state here)</div>}
        </>
    );
}

export default SegmentList;